import { Spinner } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getFriendMatch } from '../../../../commons/api'
import ItemPartenaireAccept from '../PartenaireAccept/item_accept'
import ItemMatch from './Item'

export default function MatchFriend() {
  const { town, district } = useParams()
  const [match, setMatch] = useState({
    town: town,
    district: district,
  })
  const [data, setData] = useState()
  useEffect(() => {
    async function getData() {
      const res = await getFriendMatch({ town, district })
      setData(res)
    }
    if (typeof window != 'undefined') {
      getData()
    }
    return () => {
      setMatch(null)
    }
  }, [town, district])
  console.log(data)
  return (
    <>
      <div className="container flex flex-col mt-10 text-center min-h-screen">
        <h3 className="font-bold text-xl mx-auto mt-10 text-center text-gray">
          Voici les partenaires disponibles.
        </h3>
        <div className="">
            {!data ? (
              <div className="mx-auto text-center">
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  className="mx-auto"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />{' '}
              </div>
            ) : (
              <div className='text-center mx-auto container mt-10 '>
                {data?.length === 0 ? (
                    <div className="text-7xl  opacity-50 mx-auto">
                      <h2>Aucune correspondance! </h2>
                    </div>
                ) : (
                  <div className="flex flex-wrap p-3">
                    {Array.from(data).map((value, index) => {
                      return <ItemMatch {...value} />
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
      </div>
    </>
  )
}
